module.exports = __webpack_public_path__ + "static/media/the-beetle.34d83d02.jpg";